import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useLayoutContext } from '../../../components/layout/Layout';
import { getMakecodeArcadePageRootStyle } from '../makecodeArcadePageStyles';
import Card from '../../../components/ui/Card';
import ExtensionIcon from '../../../components/icons/ExtensionIcon';

const Explains: React.FC = () => {
  const navigate = useNavigate();
  const { isMobile } = useLayoutContext();
  const explains = [
    { title: '화면에 텍스트 표시하기', path: '/makecodearcade/explains/TextSprite', description: '텍스트를 스프라이트로 표시하는 블록', icon: '📝' },
    { title: '컷신 추가하기', path: '/makecodearcade/explains/Story', description: '게임의 배경을 만들 수 있는 타일맵 블록', icon: '🧱' },
    {
      title: '화면 스크롤 설정하기',
      path: '/makecodearcade/explains/ScreenScroll',
      description: '배경 스크롤·패럴랙스와 카메라 따라가기',
      icon: '📜'
    },
    { title: '스프라이트', path: '/makecodearcade/explains/sprite', description: '게임 캐릭터와 스프라이트 관련 블록', icon: '👾' },
    { title: '센서', path: '/makecodearcade/explains/sensor', description: '다양한 센서 관련 블록', icon: '📡' }
  ];

  return (
    <div style={getMakecodeArcadePageRootStyle(isMobile)}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '16px' }}>
        <ExtensionIcon width={28} height={28} />
        <h1 style={{ margin: 0, fontSize: '24px', fontFamily: 'var(--font-family-primary)' }}>확장 블록 설명</h1>
      </div>
      <p style={{ margin: '0 0 24px', fontSize: '14px', color: 'var(--Color-text-normal)' }}>메이크코드 아케이드의 다양한 확장 블록들을 확인하고 사용해보세요. 각 블록은 게임 개발에 필요한 특정 기능을 제공합니다.</p>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: '24px' }}>
        {explains.map(explain => (
          <Card key={explain.path} padding="20px" onClick={() => navigate(explain.path)} style={{ cursor: 'pointer' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px' }}><span style={{ fontSize: '24px' }}>{explain.icon}</span><h2 style={{ margin: 0, fontSize: '18px', fontWeight: 600 }}>{explain.title}</h2></div>
            <p style={{ margin: 0, fontSize: '14px', color: 'var(--Color-text-normal)' }}>{explain.description}</p>
          </Card>
        ))}
      </div>
    </div>
  );
};

export default Explains;
